import React from 'react';

export default (props) => {
    onclick = (act) => {
        if (act.value) {
            props.store.dispatch({
                type: 'WEB_CHAT/SEND_MESSAGE',
                payload: { text: act.value }
            });

            props.cleanSuggestions();
        }
    }

    return (
        <div className="defaultcard_suggestions">
            {props.suggestions.actions ?
                <ul>
                    {props.suggestions.actions.map((act, ind) =>
                        <li key={ind}><button type="button" key={ind} onClick={() => onclick(act)}>{act.title}</button></li>
                    )}
                </ul> :
                <div></div>}
        </div>);
}